import { render } from "./IconSettings.vue?vue&type=template&id=633fdf5c"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__